import { IValidationErrors } from '@/components/atoms/form/validation/validation-errors.interface';
import { IValidatorFunction } from '@/components/atoms/form/validation/validator-function.interface';

export class EmailValidator {

    public static isEmail(): IValidatorFunction<string> {
        return (value, name, message): IValidationErrors | null => {
            if (value.length === 0) {
                return null;
            }

            return this.regExp.test(value) ? null : { [name]: message };
        }
    }

    private static regExp = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

}
